export default __webpack_public_path__ + "static/media/text-img-02.f68902fe.svg";